import { gsap } from 'gsap/dist/gsap';
import { searchLightboxes } from '../components/search'
import { buttonScrollDown } from '../animation/button-scroll-down'
import { triggerPlusPlanLightbox, numberOfUsersControl, createPlusPlanCheckout } from '../components/pricing-table'

export default {
  init() {

    searchLightboxes()
    buttonScrollDown()
    triggerPlusPlanLightbox()
    numberOfUsersControl()
    createPlusPlanCheckout()

    /**************************************************************
    -> Match heights of passed selector to the height of the 
    -> largest element
    **************************************************************/
    function matchHeight(selector) {
      const features = Array.from(document.querySelectorAll(selector))

      if(window.innerWidth > 768) {
        const heights = []

        features.forEach(feature => {
          heights.push(Math.floor(feature.getBoundingClientRect().height))
        });

        features.forEach(feature => {
          feature.style.height = `${Math.max.apply(null, heights)}px`
        });
      } else {
        features.forEach(feature => {
          feature.style.height = 'auto'
        });
      }
    }

    // Run on page load
    matchHeight('.plan-features')
    matchHeight('.plan-description')

    // Recheck on viewport size update
    window.addEventListener('resize', () => {
      matchHeight('.plan-features')
      matchHeight('.plan-description')
    });

    /**************************************************************
    -> Animate hero hovers
    **************************************************************/ 
    function heroHovers() {
      const gemstoneQuickLink = document.querySelector('.gemstone-quick-link.desktop')
      const gemstoneText = document.querySelector(['.gemstone-text.desktop'])
      const gemstoneIcon = document.querySelector(['.gemstone-icon.desktop'])
      const periodQuickLink = document.querySelector('.period-quick-link.desktop')
      const periodText = document.querySelector(['.period-text.desktop'])
      const periodIcon = document.querySelector(['.period-icon.desktop'])

      gemstoneQuickLink.addEventListener('mouseenter', () => {
        gsap.to(gemstoneText, { y: '-1rem', ease: 'power2.out', duration: 0.3 })
        gsap.to(gemstoneIcon, { scale: 1.05, ease: 'power2.out', duration: 0.3 })
      })
      
      gemstoneQuickLink.addEventListener('mouseleave', () => {
        gsap.to(gemstoneText, { y: '0', ease: 'power2.out', duration: 0.3 })
        gsap.to(gemstoneIcon, { scale: 1, ease: 'power2.out', duration: 0.3 })
      })

      periodQuickLink.addEventListener('mouseenter', () => {
        gsap.to(periodText, { y: '-1rem', ease: 'power2.out', duration: 0.3 })
        gsap.to(periodIcon, { scale: 1.05, ease: 'power2.out', duration: 0.3 })
      })
      
      periodQuickLink.addEventListener('mouseleave', () => {
        gsap.to(periodText, { y: '0', ease: 'power2.out', duration: 0.3 })
        gsap.to(periodIcon, { scale: 1, ease: 'power2.out', duration: 0.3 })
      })
    }

    heroHovers()

    function heroHoversMobile() {
      const gemstoneQuickLink = document.querySelector('.gemstone-quick-link.mobile')
      const gemstoneText = document.querySelector(['.gemstone-text.mobile'])
      const gemstoneIcon = document.querySelector(['.gemstone-icon.mobile'])
      const periodQuickLink = document.querySelector('.period-quick-link.mobile')
      const periodText = document.querySelector(['.period-text.mobile'])
      const periodIcon = document.querySelector(['.period-icon.mobile'])

      gemstoneQuickLink.addEventListener('mouseenter', () => {
        gsap.to(gemstoneText, { y: '-1rem', ease: 'power2.out', duration: 0.3 })
        gsap.to(gemstoneIcon, { scale: 1.05, ease: 'power2.out', duration: 0.3 })
      })
      
      gemstoneQuickLink.addEventListener('mouseleave', () => {
        gsap.to(gemstoneText, { y: '0', ease: 'power2.out', duration: 0.3 })
        gsap.to(gemstoneIcon, { scale: 1, ease: 'power2.out', duration: 0.3 })
      })

      periodQuickLink.addEventListener('mouseenter', () => {
        gsap.to(periodText, { y: '-1rem', ease: 'power2.out', duration: 0.3 })
        gsap.to(periodIcon, { scale: 1.05, ease: 'power2.out', duration: 0.3 })
      })
      
      periodQuickLink.addEventListener('mouseleave', () => {
        gsap.to(periodText, { y: '0', ease: 'power2.out', duration: 0.3 })
        gsap.to(periodIcon, { scale: 1, ease: 'power2.out', duration: 0.3 })
      })
    }

    heroHoversMobile()


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-discover.js